document.addEventListener("DOMContentLoaded", function () {
  // ---------------------------------------------------------
  // CONFIG — fill in your EmailJS values before publishing
  // These come from the same EmailJS account used on the repair form.
  // ---------------------------------------------------------
  // Account-level values, shared with the repair form's EmailJS setup.
  var EMAILJS_PUBLIC_KEY  = "Aq7MSsGsfCJr5Lc3_";
  var EMAILJS_SERVICE_ID  = "service_tpehjjf";

  // Internal notification sent the moment the customer submits — this fires
  // before checkout/payment, so it's a "new signup" alert, not an order
  // confirmation. Needs a NEW template in the same EmailJS account —
  // template_deeb8px (the repair form's) expects different fields
  // (make/model/issues/etc.) and can't be reused as-is. Set that template's
  // "To Email" field to the literal address jef@superseedstudio.com.
  var EMAILJS_ADMIN_TEMPLATE_ID = "template_r80b7vj";

  // The customer-facing confirmation (with the real Shopify order number) is
  // handled separately, from the Order Status page after checkout completes —
  // see order-confirmation-email.liquid. It cannot be sent from here, because
  // Shopify hasn't created the order or assigned a number yet at this point.

  if (typeof emailjs === "undefined") {
    console.error("EmailJS SDK not found. Make sure the EmailJS <script> tag is included before this file.");
    return;
  }
  emailjs.init(EMAILJS_PUBLIC_KEY);

  var PLANS = {
    bronze: {
      label: "Protect+ Bronze",
      handle: "protect-bronze-plan",
      devices: ["iPhone 7", "iPhone 7 Plus", "iPhone 8", "iPhone 8 Plus", "iPhone SE (2020)", "iPhone SE (2022)"]
    },
    silver: {
      label: "Protect+ Silver",
      handle: "protect-silver-plan",
      devices: ["iPhone X", "iPhone XR", "iPhone XS", "iPhone XS Max", "iPhone 11"]
    },
    gold: {
      label: "Protect+ Gold",
      handle: "protect-gold-plan",
      devices: [
        "iPhone 11 Pro", "iPhone 11 Pro Max",
        "iPhone 12 mini", "iPhone 12", "iPhone 12 Pro", "iPhone 12 Pro Max",
        "iPhone 13 mini", "iPhone 13", "iPhone 13 Pro", "iPhone 13 Pro Max"
      ]
    },
    platinum: {
      label: "Protect+ Platinum",
      handle: "protect-platinum-plan",
      devices: [
        "iPhone 14", "iPhone 14 Plus", "iPhone 14 Pro", "iPhone 14 Pro Max",
        "iPhone 15", "iPhone 15 Plus", "iPhone 15 Pro", "iPhone 15 Pro Max",
        "iPhone 16", "iPhone 16 Plus", "iPhone 16 Pro", "iPhone 16 Pro Max"
      ]
    }
  };

  var state = { step: 1, plan: null, device: null };
  var totalSteps = 4;

  var root = document.getElementById("pp-form-root");
  if (!root) return; // form not on this page

  var stepperEl = document.getElementById("pp-stepper");
  var planGrid = document.getElementById("pp-plan-grid");
  var deviceGrid = document.getElementById("pp-device-grid");
  var deviceSubtitle = document.getElementById("pp-device-subtitle");
  var summaryEl = document.getElementById("pp-summary");
  var formEl = document.getElementById("pp-form");

  // Build stepper
  function renderStepper() {
    var html = "";
    for (var i = 1; i <= totalSteps; i++) {
      var cls = "pp-step-circle";
      var content = i;
      if (i < state.step) { cls += " done"; content = "&#10003;"; }
      else if (i === state.step) { cls += " active"; }
      html += '<div class="' + cls + '">' + content + "</div>";
      if (i < totalSteps) {
        html += '<div class="pp-step-line' + (i < state.step ? " done" : "") + '"></div>';
      }
    }
    stepperEl.innerHTML = html;
  }

  function goToStep(n) {
    state.step = n;
    document.querySelectorAll(".pp-panel").forEach(function (p) {
      p.classList.toggle("active", parseInt(p.dataset.step, 10) === n);
    });
    renderStepper();
    if (n === 4) renderSummary();
  }

  // Build plan cards
  Object.keys(PLANS).forEach(function (key) {
    var card = document.createElement("button");
    card.type = "button";
    card.className = "pp-plan-card";
    card.textContent = PLANS[key].label;
    card.dataset.plan = key;
    card.addEventListener("click", function () {
      state.plan = key;
      state.device = null;
      document.querySelectorAll(".pp-plan-card").forEach(function (c) { c.classList.remove("selected"); });
      card.classList.add("selected");
      hideError("pp-error-plan");
    });
    planGrid.appendChild(card);
  });

  function renderDeviceOptions() {
    deviceGrid.innerHTML = "";
    if (!state.plan) return;
    deviceSubtitle.textContent = "Compatible devices for " + PLANS[state.plan].label + ".";
    PLANS[state.plan].devices.forEach(function (device) {
      var pill = document.createElement("button");
      pill.type = "button";
      pill.className = "pp-pill";
      pill.textContent = device;
      pill.addEventListener("click", function () {
        state.device = device;
        document.querySelectorAll(".pp-pill").forEach(function (p) { p.classList.remove("selected"); });
        pill.classList.add("selected");
        hideError("pp-error-device");
      });
      deviceGrid.appendChild(pill);
    });
  }

  function renderSummary() {
    var name = document.getElementById("pp-name").value;
    var email = document.getElementById("pp-email").value;
    var phone = document.getElementById("pp-phone").value;
    var imei = document.getElementById("pp-imei").value;
    summaryEl.innerHTML =
      row("Plan", PLANS[state.plan].label) +
      row("Device", state.device) +
      row("IMEI", imei) +
      row("Name", name) +
      row("Email", email) +
      row("Phone", phone);
  }
  function row(label, value) {
    return '<div class="pp-summary-row"><span>' + label + "</span><span>" + value + "</span></div>";
  }

  function showError(id) { document.getElementById(id).classList.add("show"); }
  function hideError(id) { document.getElementById(id).classList.remove("show"); }

  // Step 1 -> 2
  document.getElementById("pp-next-1").addEventListener("click", function () {
    if (!state.plan) { showError("pp-error-plan"); return; }
    renderDeviceOptions();
    goToStep(2);
  });

  // Step 2 -> 3
  document.getElementById("pp-next-2").addEventListener("click", function () {
    if (!state.device) { showError("pp-error-device"); return; }

    var imei = document.getElementById("pp-imei").value.trim();
    var imeiOk = /^\d{15}$/.test(imei);
    if (!imeiOk) { showError("pp-error-imei"); return; }
    hideError("pp-error-imei");

    goToStep(3);
  });

  // Step 3 -> 4
  document.getElementById("pp-next-3").addEventListener("click", function () {
    var name = document.getElementById("pp-name").value.trim();
    var email = document.getElementById("pp-email").value.trim();
    var phone = document.getElementById("pp-phone").value.trim();
    var ok = true;
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!name) { showError("pp-error-name"); ok = false; } else hideError("pp-error-name");
    if (!emailOk) { showError("pp-error-email"); ok = false; } else hideError("pp-error-email");
    if (!phone) { showError("pp-error-phone"); ok = false; } else hideError("pp-error-phone");

    if (ok) goToStep(4);
  });

  // Back buttons
  document.querySelectorAll("[data-back]").forEach(function (btn) {
    btn.addEventListener("click", function () { goToStep(parseInt(btn.dataset.back, 10)); });
  });

  // Submit
  formEl.addEventListener("submit", function (e) {
    e.preventDefault();

    var termsChecked = document.getElementById("pp-terms-check").checked;
    if (!termsChecked) { showError("pp-error-terms"); return; }
    hideError("pp-error-terms");

    var submitBtn = document.getElementById("pp-submit-btn");
    submitBtn.disabled = true;
    submitBtn.textContent = "Processing...";

    var name = document.getElementById("pp-name").value.trim();
    var email = document.getElementById("pp-email").value.trim();
    var phone = document.getElementById("pp-phone").value.trim();
    var imei = document.getElementById("pp-imei").value.trim();
    var plan = PLANS[state.plan];
    var device = state.device;

    // 1. Send internal "new signup" notification (best-effort, doesn't block checkout)
    //    Recipient is set directly in the EmailJS template's "To Email" field
    //    (jef@superseedstudio.com), not passed from here.
    var adminEmailPromise = emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_ADMIN_TEMPLATE_ID, {
      plan_name: plan.label,
      device: device,
      imei: imei,
      customer_name: name,
      customer_email: email,
      customer_phone: phone
    }).catch(function (err) {
      console.error("Admin EmailJS send failed:", err);
    });

    // 2. Look up the product's variant, add to cart — line item properties
    //    carry the plan/device/contact details through to the Order Status
    //    page, where the post-checkout confirmation email reads them back.
    fetch("/products/" + plan.handle + ".js")
      .then(function (res) {
        if (!res.ok) throw new Error("Could not load product " + plan.handle);
        return res.json();
      })
      .then(function (product) {
        var variantId = product.variants[0].id;
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties: {
                "Plan": plan.label,
                "Device": device,
                "IMEI": imei,
                "Customer Name": name,
                "Customer Phone": phone
              }
            }]
          })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error("Could not add plan to cart");
        return res.json();
      })
      .then(function () {
        return adminEmailPromise;
      })
      .then(function () {
        window.location.href = "/checkout";
      })
      .catch(function (err) {
        console.error(err);
        submitBtn.disabled = false;
        submitBtn.textContent = "Continue to checkout";
        alert("Something went wrong adding your plan to cart. Please try again.");
      });
  });

  renderStepper();
});
